import React, { Component } from "react";

import MainLayout from "../Layouts/MainLayout";
import { connect } from "react-redux";
import { Fragment } from "redux-little-router";
import LoginPage from "./LoginPage";
import ExternalRedirect from "../../components/ExternalRedirect";
import InternalRedirect from "../../components/InternalRedirect";
import { isLoggedInUser, selectUser } from "../../util/selectors";
import { Loader } from "semantic-ui-react";
import NotFoundPage from "../../scenes/App404";
import Raven from "../../services/raven";
import { RouteAccessState } from "../../constants";
import { reload } from "../../util/windowLocation";

const ErrorPage = () => (
  <div className="fullscreen">
    An error has occured, please refresh the page.
    <button className="button -rounded -outline" onClick={() => reload()}>
      refresh
    </button>
  </div>
);

const LoadingPage = () => (
  <div className="fullscreen">
    <Loader size="large" active inline="centered" />
  </div>
);

const AccessManagedComponent = ({ path, access, user, component }) => {
  switch (access) {
    case RouteAccessState.public:
      return component;
    case RouteAccessState.loggedInOnly:
      if (user) {
        return component;
      }
      else if (path !== "/") {
        return <InternalRedirect href={"/"} />
      }
      else if (process.env.NODE_ENV === "production") {
        return <ExternalRedirect url="/" />
      }
        return <LoginPage />

    case RouteAccessState.loggedOutOnly:
      return !user ? component : <InternalRedirect href="/" />;
    case RouteAccessState.AdminOnly:
      return user && user.isAdmin ? component : <NotFoundPage />;
    default:
      return component;
  }
};

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    Raven.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    let { user, path, layout: Layout = MainLayout, component: PageComponent, access } = this.props;

    if (user === undefined) {
      return <LoadingPage />;
    }

    const toBeRenderedComponent = (
      <Layout
        authorized={this.props.authorized}
        user={this.props.user}
        isEmailVerificationBannerVisible={this.props.isEmailVerificationBannerVisible}
        isEmailVerificationBannerDismissed={this.props.isEmailVerificationBannerDismissed}
        isCookiesBarVisible={this.props.isCookiesBarVisible}
      >
        <PageComponent />
      </Layout>
    );
    return (
      <Fragment forRoute={path}>
        <AccessManagedComponent path={path} access={access} user={user} component={toBeRenderedComponent} />
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    authorized: isLoggedInUser(state),
    user: selectUser(state),
    isEmailVerificationBannerVisible: state.user.isEmailVerificationBannerVisible,
    isEmailVerificationBannerDismissed: state.user.isEmailVerificationBannerDismissed,
    isCookiesBarVisible: state.user.isCookiesBarVisible,
  };
};

export default connect(mapStateToProps)(Page);



// WEBPACK FOOTER //
// ./src/util/Router/Page.js